module.exports = __webpack_public_path__ + "static/media/design-classic-stack.b97dea43.png";